import { memo, useEffect, useRef, useState } from "react";
import CopyText from "../copyText/copyText";
import CheckBox from "../checkbox/checkbox";
import Popover from "../popover/popover";
import { useAppSelector } from "redux-share/hooks";
import { sendFluentLog, shareDialogLog } from "../../../../../logs";
import { conditions, secondsToHMS, videoTag } from "helpers";
import { ConditionName, IShareDialogProps } from "interfaces";
import useOnClickOutside from "helpers/hooks/useOnClickOutside";
import { handlePopoverSizeInMiniPlayer } from "helpers/helpers";
import { shallowEqual } from "react-redux";
import CloseIcon from "../../icon-components/closeIcon";

const ShareDialog = ({ status, onClose, currentTime, markerId }: IShareDialogProps) => {
    const [hasStartTime, setHasStartTime] = useState<boolean>(!!markerId);

    useAppSelector(({ controller: { showMiniPlayer } }) => ({ showMiniPlayer }), shallowEqual);
    useAppSelector(({ videoData: { params, videoElementSizeInfo } }) => ({ params, videoElementSizeInfo }), shallowEqual);

    let url = window.location.href;
    if (url.includes("?")) {
        url = url.split("&t=", 1)[0];
        if (hasStartTime) url = `${url}&t=${(currentTime ? currentTime : 0).toFixed(0)}`;
    } else {
        if (hasStartTime) url = `${url}?t=${(currentTime ? currentTime : 0).toFixed(0)}`;
    }

    useEffect(() => {
        setHasStartTime(!!markerId);
    }, [markerId, status]);

    const handleCloseModal = () => {
        onClose();
        setTimeout(() => setHasStartTime(false), 500);
    };

    const handleShare = async () => {
        sendFluentLog(
            shareDialogLog(
                videoTag().currentTime ? Number(videoTag().currentTime.toFixed(0)) : 0,
                hasStartTime,
                Number((currentTime ? currentTime : 0).toFixed(0)),
                markerId
            )
        );
        navigator.share({ url });
        handleCloseModal();
    };
    const shareRef = useRef<any>(null);

    useOnClickOutside(shareRef, () => onClose());

    const customHeader = (
        <div className="pl-flex pl-items-center pl-gap-2 pl-pb-3">
            <div className={`pl-rounded-[4px] pl-p-1 pl-cursor-pointer pl-bg-gray-100`} onClick={handleCloseModal}>
                <CloseIcon className={`pl-w-3 pl-h-3 pl-stroke-gray-800`} />
            </div>
            <p className={`pl-text-[14px] pl-font-bold pl-text-black dark:pl-text-gray-100`}>اشتراک گذاری</p>
        </div>
    );

    const share = (
        <div className="pl-flex pl-flex-col pl-gap-4 pl-px-4" ref={shareRef}>
            <div className="pl-flex pl-gap-3">
                <CopyText isJump={hasStartTime} videoTime={Number((currentTime ? currentTime : 0).toFixed(0))} markerId={markerId} link={url} />
                <button
                    className="pl-bg-secondary-200 dark:pl-bg-dark-1 pl-p-[13.33px] pl-rounded-[8px] pl-flex pl-items-center pl-gap-[2.28px]"
                    onClick={handleShare}
                >
                    <span className="pl-w-[2.5px] pl-h-[2.5px] pl-bg-secondary-500 dark:pl-bg-secondary-50 pl-rounded-full"></span>
                    <span className="pl-w-[2.5px] pl-h-[2.5px] pl-bg-secondary-500 dark:pl-bg-secondary-50 pl-rounded-full"></span>
                    <span className="pl-w-[2.5px] pl-h-[2.5px] pl-bg-secondary-500 dark:pl-bg-secondary-50 pl-rounded-full"></span>
                </button>
            </div>
            <CheckBox
                label={`پرش به ${secondsToHMS(Number((currentTime ? currentTime : 0).toFixed(0)))}`}
                onChange={(value: boolean) => (value ? setHasStartTime(true) : setHasStartTime(false))}
                labelClassName="pl-text-[14px] pl-font-medium"
                defaultValue={!!markerId}
            />
        </div>
    );

    return (
        <>
            <Popover
                status={status}
                onClose={handleCloseModal}
                isBlurBackground={true}
                classNames={`pl-py-4 ${
                    conditions(ConditionName.isMiniPlayer) &&
                    !conditions(ConditionName.isFullMobilePortrait) &&
                    `!pl-fixed pl-rounded-r-none opacity-100`
                } ${conditions(ConditionName.isFullMobilePortrait) && "pl-border-t pl-border-t-gray-300"}`}
                styles={{
                    width: conditions(ConditionName.isMiniPlayer) && !conditions(ConditionName.isFullMobilePortrait) ? 280 : 320,
                    ...handlePopoverSizeInMiniPlayer()
                }}
                animation={
                    conditions(ConditionName.isMiniPlayer) && !conditions(ConditionName.isFullMobilePortrait)
                        ? status
                            ? "animate__fadeInLeft"
                            : "animate__fadeOutLeft"
                        : undefined
                }
                ref={shareRef}
                type={conditions(ConditionName.isMiniPlayer) && !conditions(ConditionName.isFullMobilePortrait) ? "popover" : "modal"}
                isHeader={true}
                customHeader={customHeader}
            >
                {share}
            </Popover>
        </>
    );
};

export default memo(ShareDialog);
